module.exports = __webpack_public_path__ + "img/guide3.e92c7b03.jpg";